import { Button, CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import Card from "../../Atoms/Card/Card";
import "./UserData.css";

function UserData(props) {
  // console.log(props.location.state);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [getAll, setGetAll] = useState(false);
  useEffect(() => {
    setUsers([]);
    setLoading(true);
    const getData = async () => {
      if (!props.location.state.approve) {
        const userSnapshot = await db.collection("Users").get();
        userSnapshot.forEach((doc) =>
          setUsers((prev) => [...prev, doc.data()])
        );
      } else {
        const userSnapshot = await db
          .collection("Users")
          .where("isAuthenticated", "==", false)
          .get();
        userSnapshot.forEach((doc) =>
          setUsers((prev) => [...prev, doc.data()])
        );
      }
      setLoading(false);
    };
    getData();

    //eslint-disable-next-line
  }, [getAll]);

  const searchIt = async (e) => {
    e.preventDefault();

    let keyword = search.trim();
    // keyword = keyword.charAt(0).toUpperCase() + keyword.substring(1);
    // console.log(keyword + "***");

    if (!keyword) {
      setGetAll((p) => !p);
      return;
    }
    setLoading(true);
    setUsers([]);
    try {
      let filteredUsers = await db
        .collection("Users")
        .where("firstName", "==", keyword)
        .get();

      filteredUsers.forEach((doc) =>
        setUsers((prev) => [
          ...prev.filter((itm) => itm.authID !== doc.data().authID),
          doc.data(),
        ])
      );

      filteredUsers = await db
        .collection("Users")
        .where("middleName", "==", keyword)
        .get();
      filteredUsers.forEach((doc) =>
        setUsers((prev) => [
          ...prev.filter((itm) => itm.authID !== doc.data().authID),
          doc.data(),
        ])
      );

      filteredUsers = await db
        .collection("Users")
        .where("lastName", "==", keyword)
        .get();
      filteredUsers.forEach((doc) =>
        setUsers((prev) => [
          ...prev.filter((itm) => itm.authID !== doc.data().authID),
          doc.data(),
        ])
      );

      filteredUsers = await db
        .collection("Users")
        .where("phoneNumber", "==", keyword)
        .get();
      filteredUsers.forEach((doc) =>
        setUsers((prev) => [
          ...prev.filter(
            (itm) =>
              itm.phoneNumber && itm.phoneNumber !== doc.data().phoneNumber
          ),
          doc.data(),
        ])
      );

      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
    // console.log("*******");
    // console.log(users);
    setSearch("");
  };

  return (
    <div>
      {loading ? (
        <CircularProgress
          style={{
            width: "100px",
            height: "100px",
            position: "fixed",
            left: "45vw",
            top: "40vh",
          }}
        />
      ) : (
        <>
          <div className="users__search">
            <form onSubmit={searchIt}>
              <input
                placeholder="search"
                value={search}
                onChange={(e) =>
                  setSearch(
                    e.target.value.charAt(0).toUpperCase() +
                      e.target.value.substring(1)
                  )
                }
              />
              <Button variant="contained" color="primary" onClick={searchIt}>
                Search
              </Button>
            </form>
            <Button
              variant="contained"
              color="secondary"
              style={{ marginLeft: "5px" }}
              onClick={() => setGetAll((p) => !p)}
            >
              All
            </Button>
          </div>
          <div className="users__list">
            {users.map((user) => (
              <Card key={user.authID} data={user} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default UserData;
